import { render, staticRenderFns } from "./PlatformViewPrizes.vue?vue&type=template&id=1b7de1c8&scoped=true&"
import script from "./PlatformViewPrizes.vue?vue&type=script&lang=js&"
export * from "./PlatformViewPrizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7de1c8",
  null
  
)

export default component.exports